import type { ReactNode } from "react"
import { Navigate } from "react-router-dom"
import { useAuth, AuthLoadingScreen } from "@/contexts/AuthContext"

interface RequireAdminProps {
  children: ReactNode
}

export function RequireAdmin({ children }: RequireAdminProps) {
  const { isAuthenticated, isAdmin, adminLoading, loading } = useAuth()

  if (loading) return <AuthLoadingScreen />
  if (!isAuthenticated) return <Navigate to="/auth" replace />
  if (adminLoading) return <AuthLoadingScreen />
  if (!isAdmin) return <Navigate to="/dashboard" replace />

  return <>{children}</>
}
